import { AgeRange } from './AgeRange';
import { ContentItemType } from '../common/ContentItemType';
import { Platform } from '../common/Platform';
import { DeviceType } from '../common/DeviceType';
import {ContentItemCategory} from "../models/ContentItemCategory";

export class AdminUserSettings implements IAdminUserSettings {
    ageRanges?: AgeRange[] | undefined;
    deviceTypes?: DeviceType[] | undefined;
    platforms?: Platform[] | undefined;
    contentItemTypes?: ContentItemType[] | undefined;
    contentItemCategories?: ContentItemCategory[] | undefined;

    constructor(data?: IAdminUserSettings) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ageRanges"])) {
                this.ageRanges = [] as any;
                for (const item of _data["ageRanges"])
                    this.ageRanges!.push(AgeRange.fromJS(item));
            }
            if (Array.isArray(_data["deviceTypes"])) {
                this.deviceTypes = [] as any;
                for (const item of _data["deviceTypes"])
                    this.deviceTypes!.push(DeviceType.fromJS(item));
            }
            if (Array.isArray(_data["platforms"])) {
                this.platforms = [] as any;
                for (const item of _data["platforms"])
                    this.platforms!.push(Platform.fromJS(item));
            }
            if (Array.isArray(_data["contentItemTypes"])) {
                this.contentItemTypes = [] as any;
                for (const item of _data["contentItemTypes"])
                    this.contentItemTypes!.push(ContentItemType.fromJS(item));
            }
            if (Array.isArray(_data["contentItemCategories"])) {
                this.contentItemCategories = [] as any;
                for (const item of _data["contentItemCategories"])
                    this.contentItemCategories!.push(ContentItemCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminUserSettings {
        data = typeof data === 'object' ? data : {};
        const result = new AdminUserSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ageRanges)) {
            data["ageRanges"] = [];
            for (const item of this.ageRanges)
                data["ageRanges"].push(item.toJSON());
        }
        if (Array.isArray(this.deviceTypes)) {
            data["deviceTypes"] = [];
            for (const item of this.deviceTypes)
                data["deviceTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.platforms)) {
            data["platforms"] = [];
            for (const item of this.platforms)
                data["platforms"].push(item.toJSON());
        }
        if (Array.isArray(this.contentItemTypes)) {
            data["contentItemTypes"] = [];
            for (const item of this.contentItemTypes)
                data["contentItemTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.contentItemCategories)) {
            data["contentItemCategories"] = [];
            for (const item of this.contentItemCategories)
                data["contentItemCategories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAdminUserSettings {
    ageRanges?: AgeRange[] | undefined;
    deviceTypes?: DeviceType[] | undefined;
    platforms?: Platform[] | undefined;
    contentItemTypes?: ContentItemType[] | undefined;
    contentItemCategories?: ContentItemCategory[] | undefined;
}
